import { Reveal } from "./Reveal";
import { CHAPTERS, AGENT } from "../data/site";
import { ShieldCheck, HeartHandshake, MapPin } from "lucide-react";

const PROMISES = [
  { icon: ShieldCheck, label: "Independent", detail: "I answer to you, not a carrier" },
  { icon: HeartHandshake, label: "$0 to you", detail: "My guidance is always free" },
  { icon: MapPin, label: "Licensed in Maryland", detail: "Serving neighbors close to home" },
];

export default function Manifesto() {
  return (
    <section id="about" className="py-24 md:py-32 bg-[#EAE3D9]" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <Reveal>
            <div className="sticky top-28 bg-[#1E3A2F] rounded-3xl p-10 md:p-12 shadow-[0_20px_50px_rgba(30,58,47,0.25)]" data-testid="about-promise-panel">
              <span className="text-6xl font-display text-[#E8A365] leading-none">&ldquo;</span>
              <p className="font-display text-2xl md:text-3xl leading-snug text-[#F9F6F0] -mt-4">
                The families I serve aren't policies; they're people I get to help.
              </p>
              <p className="mt-4 text-sm uppercase tracking-[0.2em] text-[#E8A365] font-bold">
                — {AGENT.firstName}
              </p>

              <div className="mt-10 pt-8 border-t border-[#F9F6F0]/15 space-y-6">
                {PROMISES.map((p) => (
                  <div key={p.label} className="flex items-start gap-4">
                    <p.icon className="w-6 h-6 text-[#E8A365] shrink-0 mt-0.5" />
                    <div>
                      <p className="font-semibold text-[#F9F6F0]">{p.label}</p>
                      <p className="text-sm text-[#F9F6F0]/70">{p.detail}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal>
            <p className="text-sm uppercase tracking-[0.25em] font-bold text-[#C85A40] mb-4">The way I work</p>
            <h2 className="font-display text-4xl md:text-5xl tracking-tight leading-tight text-[#1A1714] mb-14">
              A neighbor with a license, not a call center
            </h2>
          </Reveal>

          <div className="space-y-12">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.num} delay={i * 0.08}>
                <div className="border-t border-[#C85A40]/30 pt-6" data-testid={`chapter-${i + 1}`}>
                  <p className="text-sm uppercase tracking-[0.2em] font-bold text-[#C85A40]">{c.num}</p>
                  <h3 className="mt-3 font-display text-2xl md:text-3xl tracking-tight text-[#1A1714]">{c.title}</h3>
                  <p className="mt-3 text-[#4A453F] leading-relaxed text-lg max-w-xl">{c.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
